var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSustainabilityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2480_5642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3125 68.9326C8.60374 89.6727 27.8766 104.522 51.0841 104.522C79.3377 104.522 102.59 82.5148 104.412 54.6836",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0477 84.9835C59.0867 95.2313 13.3164 102.789 1.3125 68.8672",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2969 80.9822C31.7453 78.5369 33.9905 68.7115 47.0836 65.266C52.2631 63.91 57.687 63.8878 62.9554 64.8214C68.2238 65.755 73.4032 67.3111 78.6716 68.0891C83.9844 68.8672 88.8082 69.2451 93.7431 67.1333C98.6558 64.9992 102.613 60.0199 104.391 54.707",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4138 17.3164L29.6992 24.5854V66.8213",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7617 43.9707V54.7075",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7842 60.2187L13.7812 54.6836",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.78125 60.2187L13.7619 54.6836",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7617 76.4904V63.6641",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6987 12.1592C28.076 10.0474 25.4973 8.69141 22.6298 8.69141C17.7393 8.69141 13.8047 12.5816 13.8047 17.3831C13.8047 18.0944 13.8714 18.7613 14.0492 19.4282",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9608 19.3398C13.3161 19.1619 12.627 19.0508 11.9157 19.0508C7.98107 19.0508 4.75781 22.2074 4.75781 26.1642C4.75781 30.121 7.95885 33.2776 11.9157 33.2776C13.6718 33.2776 15.2945 32.6552 16.5394 31.6104",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7846 35.3217C18.7611 35.3217 15.5156 32.0763 15.5156 28.0527",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4121 2.15619C39.3229 1.66714 38.1225 1.40039 36.8554 1.40039C31.9427 1.40039 27.9414 5.42391 27.9414 10.3811",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7149 53.4623C83.7149 56.9745 80.8918 59.7754 77.3796 59.7754H70.5107V52.2841C70.5107 52.2841 56.9508 56.9523 54.5944 53.6624C53.3718 51.9729 53.483 50.4613 53.7497 49.5721C54.0609 48.4607 54.1721 47.3492 53.8609 46.2377C53.7497 45.7487 53.5941 45.393 53.3718 45.2374C52.5716 44.615 54.7945 42.6366 54.7945 42.6366C54.7945 42.6366 52.0381 41.5251 52.1937 41.0361C52.3048 40.6137 53.7275 38.4797 53.6163 37.9017C53.4607 37.3237 50.1041 36.9458 49.6151 36.4123C49.126 35.8788 54.839 29.788 53.8609 18.6733L53.8164 18.6288C57.7066 20.6072 63.2194 22.2967 71.2665 22.9858M71.3109 22.9636C87.4273 24.3418 84.5597 38.5908 83.2259 40.8138C84.5597 38.5908 87.4273 24.364 71.3109 22.9636ZM71.3109 22.9636C46.4585 20.8518 45.1914 9.15911 45.1914 9.15911C45.1914 9.15911 54.0832 12.7603 61.5745 6.93617C66.7317 2.91265 72.1779 3.15717 72.1779 3.15717C81.9144 3.15717 90.5838 9.15911 90.1615 15.4723V14.9832C90.1615 11.2709 93.0291 8.2477 96.5413 8.2477C100.587 8.2477 102.988 11.7599 102.988 15.4723",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2480_5642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105.812,
    height: 105.901,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainabilityIcon);
export default __webpack_public_path__ + "static/media/sustainability-icon.0ce4c64f.svg";
export { ForwardRef as ReactComponent };